import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register PWA service worker — silent, non-blocking.
// Enabled in both dev & prod so the app is installable from the preview URL too.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('SW registration failed:', err);
      });
  });
}

// Force layout refresh on orientation change (iPadOS Safari sometimes keeps
// stale viewport dimensions when rotating, leaving empty margins around the
// app). Update a CSS variable + dispatch a synthetic resize so any
// component using visualViewport recomputes.
function refreshViewport() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--app-vh', `${vh}px`);
  document.documentElement.style.setProperty('--app-vw', `${window.innerWidth}px`);
}
refreshViewport();
window.addEventListener('resize', refreshViewport, { passive: true });
window.addEventListener('orientationchange', () => {
  // iPadOS/iOS need a small delay to report the new dimensions correctly.
  setTimeout(() => {
    refreshViewport();
    // Trigger a reflow so Tailwind's dynamic viewport units get re-evaluated.
    document.body.style.minHeight = '100dvh';
    window.dispatchEvent(new Event('resize'));
  }, 100);
}, { passive: true });
